import type { TimeRange } from "@/types/appointments/api-types/availability-types";
import type { StaffRosterOverrideFormValues } from "@/zod-schemas/staff/staff-roster-override-schema";

const FALLBACK_START_TIME = "09:00";
const FALLBACK_END_TIME = "17:00";

export const getStaffRosterOverrideFormValues = (
  workingHours: TimeRange[]
): StaffRosterOverrideFormValues => {
  const window = workingHours[0];
  if (window) {
    return {
      is_working: true,
      start_time: window.start_time,
      end_time: window.end_time,
    };
  }

  return {
    is_working: false,
    start_time: FALLBACK_START_TIME,
    end_time: FALLBACK_END_TIME,
  };
};
